import { useGetExperienceVetting } from '@/features/experience-vetting/queries/use-get-experience-vetting.ts'
import { ExpVettingVersionsSelect } from './exp-vetting-versions-select'

export const ExpVettingHeaderEndSlot = ({
	experienceId
}: {
	experienceId: number
}) => {
	const { data } = useGetExperienceVetting(experienceId)
	return (
		<div>
			{data && <ExpVettingVersionsSelect experienceId={experienceId} />}
		</div>
	)
}
